export default "__VITE_ASSET__1RHbGFkm__"